/**
 * Api 文档
 */
import Axios from 'axios'
import Qs from 'qs'
import { isProd } from '../common/utils.js'

// /back-user-web/mix
// /back-user-web/mix/proposer/sendSms
Axios.defaults.baseURL = isProd ? 'https://api.callai.net' : 'https://test.callaitest.cn'
// Axios.defaults.timeout = 10000
// Axios.defaults.withCredentials =true
// Axios.defaults.headers['Content-Type'] = 'application/json'
Axios.defaults.transformRequest = (data, headers) => {
  if (typeof data === 'string' && headers['Content-Type'] !== 'application/json') {
    return Qs.stringify(JSON.parse(data))
  } else {
    return data
  }
}

export default Axios
